import React, { Component } from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { renderTextField, isInteger, renderCheckBox, renderAutoCompleteSingleSelect, normalizeRate } from '../../../../../../components/reduxFields'
import { connect } from 'react-redux';
import { CommonButton } from '../../../../../../components/buttons'
import { getPatientMasterCriteriaDetail, savePatientMasterCriteria, getMasterData } from './actions/MasterCriteriaActions';
import { Divider } from 'material-ui';

const validate = (values) => {
    const errors = {};
    if (!values.responsePercentage) {
      errors.responsePercentage = 'Please enter response percentage';
    }
    else if (values.responsePercentage && values.responsePercentage < 1) {
        errors.responsePercentage = 'Response percentage should be great than 0';
    }

    if (!values.consecutiveDayId) {
        errors.consecutiveDayId = 'Please select consecutive days';
    }

    if (!values.firstTrialMustBeIndependentId) {
        errors.firstTrialMustBeIndependentId = 'Please select first trial must be independent';
    }

    if (!values.minimumNumberOfTrialsRequiredPerDay) {
      errors.minimumNumberOfTrialsRequiredPerDay = 'Please enter minimum number of trials required per day';
    }
    else if (values.minimumNumberOfTrialsRequiredPerDay && values.minimumNumberOfTrialsRequiredPerDay < 1) {
        errors.minimumNumberOfTrialsRequiredPerDay = 'Minimum number of trials required per day should be great than 0';
    }
    if (!values.minimumNumberOfTherapists) {
        errors.minimumNumberOfTherapists = 'Please enter minimum number of therapists';
    }
    else if (values.minimumNumberOfTherapists && values.minimumNumberOfTherapists < 1) {
        errors.minimumNumberOfTherapists = 'minimum number of therapists should be great than 0';
    }


    if (!values.responseCriteriaFrequency) {
        errors.responseCriteriaFrequency = 'Please enter response criteria';
    }
    else if (values.responseCriteriaFrequency && values.responseCriteriaFrequency < 1) {
        errors.responseCriteriaFrequency = 'Response criteria should be great than 0';
    }
    else if (values.responseCriteriaFrequency > 100) {
        errors.responseCriteriaFrequency = 'Response criteria can not be greater than 100.';
    }

    if (!values.consecutiveFrequencyDayId) {
        errors.consecutiveFrequencyDayId = 'Please select consecutive days';
    }

    if (!values.minimumNumberOfFrequencyTherapists) {
        errors.minimumNumberOfFrequencyTherapists = 'Please enter minimum number of therapists';
    }
    else if (values.minimumNumberOfFrequencyTherapists && values.minimumNumberOfFrequencyTherapists < 1) {
        errors.minimumNumberOfFrequencyTherapists = 'minimum number of therapists should be great than 0';
    }


    if (!values.responseCriteriaDuration) {
        errors.responseCriteriaDuration = 'Please enter response criteria';
    }
    else if (values.responseCriteriaDuration && values.responseCriteriaDuration < 1) {
        errors.responseCriteriaDuration = 'Response criteria should be great than 0';
    }
    else if (values.responseCriteriaDuration > 100) {
        errors.responseCriteriaDuration = 'Response criteria can not be greater than 100.';
    }
    if (!values.consecutiveDurationDayId) {
        errors.consecutiveDurationDayId = 'Please select consecutive days';
    }

    if (!values.minimumNumberOfDurationTherapists) {
        errors.minimumNumberOfDurationTherapists = 'Please enter minimum number of therapists';
    }
    else if (values.minimumNumberOfDurationTherapists && values.minimumNumberOfDurationTherapists < 1) {
        errors.minimumNumberOfDurationTherapists = 'minimum number of therapists should be great than 0';
    }
    return errors;
  };

class MasteryCriteria extends Component {
    constructor(props) {
        super(props);
        this.handleNewRequest = this.handleNewRequest.bind(this);
    }

    componentDidMount() {
        const masterData = { masterdata: 'MASTERCONSECUTIVEDAYS,MASTERFIRSTTRIALMUSTBEINDEPENDENT,FIRSTMASTERYCHECK,SECONDMASTERYCHECK,THIRDMASTERYCHECK' }
        this.props.getMasterData(masterData);
        this.props.getPatientMasterCriteriaDetail(this.props.patientId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_patientMasterCriteria && nextProps.saved_patientMasterCriteria !== this.props.saved_patientMasterCriteria) {
            this.props.getPatientMasterCriteriaDetail(this.props.patientId);
        }
    }

    handleNewRequest(input, selectedRecord) {
        input.onChange(selectedRecord.value);
    }

    onSubmit(formProps) {
        formProps = {
            id: formProps.id || null,
            patientId: this.props.patientId,
            ...formProps
        }
        this.props.savePatientMasterCriteria(formProps);
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                    <div className="row">
                        <div className="col-sm-12 mt20 masteryCriteria">
                            DTT and TA Mastery Criteria
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 require">
                            <Field
                                name="responsePercentage"
                                floatingLabelText="Response Criteria or Percentage"
                                maxLength="3"
                                component={renderTextField}
                                normalize={isInteger}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-sm-4 mt-35 require">
                            <Field
                                name="consecutiveDayId"
                                label="Consecutive Day"
                                options={this.props.consecutiveDays}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                                openOnFocus={true}
                            />
                        </div>
                        <div className="col-sm-4 mt-35 require">
                            <Field
                                name="firstTrialMustBeIndependentId"
                                label="First Trial Must Be Independent"
                                options={this.props.firstTrialMustBeIndependent}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                                openOnFocus={true}
                            />
                        </div>
                        <div className="col-sm-4">
                            <Field className="mt20 mb0 custm_check"
                                name="onlyCountFirstTrial"
                                label="Only Count First Trial"
                                component={renderCheckBox}
                            />
                        </div>
                        <div className="col-sm-4 require">
                            <Field
                                name="minimumNumberOfTrialsRequiredPerDay"
                                floatingLabelText="Minimum Number Of Trials Required Per Day"
                                maxLength="3"
                                component={renderTextField}
                                normalize={isInteger}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-sm-4 require">
                            <Field
                                name="minimumNumberOfTherapists"
                                floatingLabelText="Minimum Number Of Therapists"
                                maxLength="3"
                                component={renderTextField}
                                normalize={isInteger}
                                fullWidth={true}
                            />
                        </div>
                        {/* <div className="col-sm-4 mt-35">
                            <Field
                                name="firstMasteryCheckId"
                                label="First Mastery Check"
                                options={this.props.firstMasteryCheck}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                                openOnFocus={true}
                            />
                        </div>
                        <div className="col-sm-4 mt-35">
                            <Field
                                name="secondMasteryCheckId"
                                label="Second Mastery Check"
                                options={this.props.secondMasteryCheck}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                                openOnFocus={true}
                            />
                        </div>
                        <div className="col-sm-4 mt-35">
                            <Field
                                name="thirdMasteryCheckId"
                                label="Third Mastery Check"
                                options={this.props.thirdMasteryCheck}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                                openOnFocus={true}
                            />
                        </div> */}
                    </div>
                    <div className="menudivider mt20">
                        <Divider />
                    </div>
                    <div className="row">
                        <div className="col-sm-12 mt20 masteryCriteria">
                            Frequency Mastery Criteria
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 require">
                            <Field
                                name="responseCriteriaFrequency"
                                floatingLabelText="Response Criteria or Percentage"
                                maxLength="3"
                                component={renderTextField}
                                normalize={isInteger}
                                fullWidth={true}
                            />
                            {/* <Field
                                name="responseCriteriaFrequency"
                                floatingLabelText="Response Criteria"
                                maxLength="8"
                                component={renderTextField}
                                normalize={normalizeRate}
                                fullWidth={true}
                            /> */}
                        </div>
                        <div className="col-sm-4 mt-35 require">
                            <Field
                                name="consecutiveFrequencyDayId"
                                label="Consecutive Day"
                                options={this.props.consecutiveDays}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                                openOnFocus={true}
                            />
                        </div>                       
                        <div className="col-sm-4 require">
                            <Field
                                name="minimumNumberOfFrequencyTherapists"
                                floatingLabelText="Minimum Number Of Therapists"
                                maxLength="3"
                                component={renderTextField}
                                normalize={isInteger}
                                fullWidth={true}
                            />
                        </div>
                    </div>
                    <div className="menudivider mt20">
                        <Divider />
                    </div>
                    <div className="row">
                        <div className="col-sm-12 mt20 masteryCriteria">
                            Duration Mastery Criteria
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 require">
                            <Field
                                name="responseCriteriaDuration"
                                floatingLabelText="Response Criteria or Percentage"
                                maxLength="8"
                                component={renderTextField}
                                normalize={normalizeRate}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-sm-4 mt-35 require">
                            <Field
                                name="consecutiveDurationDayId"
                                label="Consecutive Day"
                                options={this.props.consecutiveDays}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                                openOnFocus={true}
                            />
                        </div>                       
                        <div className="col-sm-4 require">
                            <Field
                                name="minimumNumberOfDurationTherapists"
                                floatingLabelText="Minimum Number Of Therapists"
                                maxLength="3"
                                component={renderTextField}
                                normalize={isInteger}
                                fullWidth={true}
                            />
                        </div>
                    </div>
                     {/* <div className="menudivider mt20">
                        <Divider />
                    </div> */}

                    {this.props.addPermission ?
                        <div className="row">
                            <div className="col-sm-12 pt20 btn_rt">
                                {this.props.loading ?
                                    <CommonButton primary={true} className="loader_btn" disabled={true} label="Saving" />
                                    : <CommonButton type="submit" primary={true} label="Save" />}
                            </div>
                        </div>
                        : null
                    }
                </form>
            </div>
        )
    }
}

//const selector = formValueSelector('PatientMasterCriteriaForm');
const mapStateToProps = (state, ownProps) => {
    let initialValueData = null;
    if (ownProps.patientId && state.patient_masterCriteria.patientMasterCriteriaDetails) {
        initialValueData = state.patient_masterCriteria.patientMasterCriteriaDetails.data;
    }
    // console.log(initialValueData)

    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_MASTERY_CRITERIA")[0].permission : false;

    // End For Role Permission

    return {
        initialValues: initialValueData,
        patientMasterCriteriaDetails: state.patient_masterCriteria.patientMasterCriteriaDetails,
        consecutiveDays: state.patient_masterCriteria.masterData && state.patient_masterCriteria.masterData.consecutiveDays,
        firstTrialMustBeIndependent: state.patient_masterCriteria.masterData && state.patient_masterCriteria.masterData.firstTrialMustBeIndependent,
        firstMasteryCheck: state.patient_masterCriteria.masterData && state.patient_masterCriteria.masterData.firstMasteryCheck,
        secondMasteryCheck: state.patient_masterCriteria.masterData && state.patient_masterCriteria.masterData.secondMasteryCheck,
        thirdMasteryCheck: state.patient_masterCriteria.masterData && state.patient_masterCriteria.masterData.thirdMasteryCheck,
        saved_patientMasterCriteria: state.patient_masterCriteria.saved_patientMasterCriteria,
        loading: state.patient_masterCriteria.loading,
        addPermission: addPermission, // For Role Permission
    };
};

MasteryCriteria = reduxForm({
    form: 'PatientMasterCriteriaForm', // a unique identifier for this form
    validate,
    enableReinitialize: true,
})(MasteryCriteria);


export default connect(mapStateToProps, { getPatientMasterCriteriaDetail, savePatientMasterCriteria, getMasterData })(MasteryCriteria);


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/masteryCriteria/index.js